import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Skeleton = styled.div<any>`
  background: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.2s infinite linear;
  border-radius: ${({ $radius }) => $radius || "8px"};
  width: ${({ $width }) => $width || "100%"};
  height: ${({ $height }) => $height || "20px"};
  margin: ${({ $margin }) => $margin || "0"};
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 24px;
  padding: 0 16px;
`;

const Card = styled.div`
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  border: 1px solid #e3e7ef;
  overflow: hidden;
  flex: 1;
`;

const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 16px;
`;

const CardTopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  background: #e5e7eb;
  padding: 0 24px;
`;

const CardBottomLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const CardBottomRight = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const SalesDashboardTargetDataSkeleton = () => {
  return (
    <Wrapper>
      {/* BEP 카드 스켈레톤 */}
      <Card>
        <CardTop>
          <Skeleton $height="20px" $width="110px" />
          <CardTopRight>
            <Skeleton $height="20px" $width="80px" />
            <Skeleton $height="24px" $width="39px" $radius="6px" />
          </CardTopRight>
        </CardTop>
        <CardBottom>
          <CardBottomLeft>
            <Skeleton $height="16px" $width="90px" />
          </CardBottomLeft>
          <CardBottomRight>
            <Skeleton $height="24px" $width="54px" $radius="12px" />
          </CardBottomRight>
        </CardBottom>
      </Card>

      {/* 목표 매출 카드 스켈레톤 */}
      <Card>
        <CardTop>
          <Skeleton $height="20px" $width="90px" />
          <CardTopRight>
            <Skeleton $height="20px" $width="90px" />
            <Skeleton $height="24px" $width="39px" $radius="6px" />
          </CardTopRight>
        </CardTop>
        <CardBottom>
          <CardBottomLeft>
            <Skeleton $height="16px" $width="120px" />
          </CardBottomLeft>
          <CardBottomRight>
            <Skeleton $height="24px" $width="54px" $radius="12px" />
          </CardBottomRight>
        </CardBottom>
      </Card>
    </Wrapper>
  );
};
